import VueJsonViewer from 'vue-json-viewer'

export default {
    name: 'RawDocumentTab',
    components: {
        VueJsonViewer
    },
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        copyToClipboard() {
            if (!this.recallData) return

            const jsonString = JSON.stringify(this.recallData, null, 2)
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(jsonString)
                    .then(() => {
                        this.$bvToast.toast('JSON copied to clipboard', {
                            title: 'Success',
                            variant: 'success',
                            solid: true,
                            autoHideDelay: 2000
                        })
                    })
                    .catch(err => {
                        console.error('Failed to copy:', err)
                        this.fallbackCopy(jsonString)
                    })
            } else {
                this.fallbackCopy(jsonString)
            }
        },

        fallbackCopy(text) {
            // Fallback method for older browsers
            const textArea = document.createElement('textarea')
            textArea.value = text
            textArea.style.position = 'fixed'
            textArea.style.left = '-999999px'
            document.body.appendChild(textArea)
            textArea.select()

            try {
                document.execCommand('copy')
                this.$bvToast.toast('JSON copied to clipboard', {
                    title: 'Success',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 2000
                })
            } catch (err) {
                console.error('Fallback: Failed to copy:', err)
                this.$bvToast.toast('Failed to copy JSON', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true,
                    autoHideDelay: 3000
                })
            }

            document.body.removeChild(textArea)
        }
    }
}
